import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const TractNumber = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      placeholder="Enter tract number"
      id="tractNumber"
      name="tractNumber"
      label="Tract Number"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default TractNumber;
